import { createContext } from 'react';

export const AppInfoContext = createContext(null);